module.exports = __webpack_public_path__ + "img/ppt.060ea651.svg";